import React from "react";
import { Container, Typography, TextField, Button, Backdrop, CircularProgress, Box } from "@mui/material";
import { Context } from "../App";
import Footer from "../components/layout/Footer";

export default function ComplementaryInfo() {
    const { userId, setUserId, region, deconnect } = React.useContext(Context);
    const [user, setUser] = React.useState(null);
    const [genre, setGenre] = React.useState('Mr');
    const [nom, setNom] = React.useState('');
    const [prenom, setPrenom] = React.useState('');
    const [mail, setMail] = React.useState('');
    const [tel, setTel] = React.useState('');
    const [voie, setVoie] = React.useState('');
    const [zip_code, setZipCode] = React.useState('');
    const [ville, setVille] = React.useState('');
    const [adresse_complement, setAdresseComplement] = React.useState('');
    const [eglise, setEglise] = React.useState('');
    const [eglises, setEglises] = React.useState([]);
    const [eglisesLoad, setEgliseLoad] = React.useState(true);
    const [loading, setLoading] = React.useState(false);


    async function handleSubmit(e) {
        e.preventDefault();
        setLoading(true);
        const userData = { genre, nom, prenom, mail, tel, voie, zip_code, ville, adresse_complement, eglise };
        console.log(userData);
        try {
            const response = await fetch(`${process.env.REACT_APP_ESDRAS_API_URL}/update/user/${userId}`, {
                method: 'PUT',
                headers: { 'Content-Type': 'application/json', 'Authorization':  `Bearer ${localStorage.getItem('token')}` },
                body: JSON.stringify(userData),
            });
            if (!response.ok) {
                if(response.status === 401) {
                    deconnect();
                    window.location.href = '/connexion';
                } else {
                    throw new Error('Failed to update user data', { cause: response.statusText });
                }
            }
            const token = response.headers.get('x-auth-token');
            if (token) {
                localStorage.setItem('token', token);
            }
            const updatedUser = await response.json(); console.log(updatedUser);
            localStorage.setItem('userData', JSON.stringify(updatedUser));
            window.location.href = '/';
        } catch (error) {
            console.error('Error updating user data:', error);
            alert('Une erreur est survenue lors de la mise à jour de votre profil. Veuillez réessayer.');
        } finally {
            setLoading(false);
        }
    }

    React.useEffect(() => {
        const storedUser = localStorage.getItem('userData');
        if (storedUser) {
            const user = JSON.parse(storedUser)
            setUser(user);
            setGenre(user.genre || 'Mr');
            setNom(user.nom || '');
            setPrenom(user.prenom || '');
            setMail(user.mail || '');
            setTel(user.tel || '');
            setVoie(user.voie || '');
            setZipCode(user.zip_code || '');
            setVille(user.ville || '');
            setAdresseComplement(user.adresse_complement || '');
            setEglise(user.eglise || '');

        } else {
            //redirect to login if no user data found
            window.location.href = '/connexion';
        }
    }, []);

    React.useEffect(()=>{
        const query = new URLSearchParams({ region, type:'église' }).toString();
    
        fetch(process.env.REACT_APP_THYBA_API_URL.concat('/public/eglises/by?'+ query), {method: 'GET'})
        .then((res) => res.json())
        .then((data) => setEglises(data.filter(e => e.type==='église')))
        .catch((err) => console.error("Error fetching eglises:", err))
        .finally(() => setEgliseLoad(false));
    }, [region])

    return (
        <Box sx={{px: 2}}>
            <Box sx={{display:'flex', justifyContent:'end', mt:2, mr:2}}>
                <a href="/"><img src={require('../assets/esdras7-bleu.png')} alt="Logo" style={{ width: '40vw', maxWidth: '200px', display: 'block' }} /></a>
            </Box>
            <h1 align='center'>Informations complémentaires</h1>
            <p align='center'>Merci de compléter votre profil pour profiter pleinement de nos services.</p>
            
            <Container component='form' onSubmit={handleSubmit} maxWidth="sm" sx={{ display:'flex', flexDirection:'column', mt: 4, rowGap:2, minWidth: '400px' }}>
                <TextField fullWidth select label="Genre" variant="outlined" value={genre} required
                onChange={(e) => setGenre(e.target.value)} slotProps={{ select: {native: true}, inputLabel:{shrink: true} }} sx={{ mb: 2 }}>
                    <option disabled value="">Sélectionnez un genre</option>
                    <option value="Mr">Monsieur</option>
                    <option value="Mme">Madame</option>
                </TextField>

                <TextField fullWidth label="Nom" variant="outlined" value={nom} required 
                onChange={(e) => setNom(e.target.value)} autoComplete="family-name" />
                <TextField fullWidth label="Prénoms" variant="outlined" value={prenom} required autoComplete="first-name"
                onChange={(e) => setPrenom(e.target.value)} />

                <TextField fullWidth label="Adresse e-mail" variant="outlined" value={mail} required type="email"
                onChange={(e) => setMail(e.target.value)} />

                <TextField fullWidth type="phone" label="GSM" variant="outlined" value={tel} autoComplete="tel"
                onChange={(e) => setTel(e.target.value)} />

                {region && <TextField fullWidth label="Eglise" variant="outlined" value={eglise} 
                onChange={(e) => setEglise(e.target.value!=="" ? Number(e.target.value) : "")} select slotProps={{ select: {native: true}, inputLabel:{shrink: true} }} sx={{ mb: 2 }}>
                    <option value="">Sélectionnez une église (optionel)</option>
                    {eglisesLoad ? <option disabled>Chargement des églises...</option> :
                    eglises.sort((a,b)=>a.nom>b.nom?1:-1).map((eglise) => (
                        <option key={eglise._id} value={eglise.number}>{eglise.nom}</option>
                    ))}
                </TextField>}

                <Typography variant="h6" sx={{ mt: 2 }}>Adresse</Typography>
                <TextField fullWidth label="Numéro et nom de la voie" variant="outlined" value={voie} autoComplete="address-line1"
                onChange={(e) => setVoie(e.target.value)} sx={{ mb: 2 }} />
                <TextField fullWidth label="Complément d'adresse" variant="outlined" value={adresse_complement} autoComplete="address-line2"
                onChange={(e) => setAdresseComplement(e.target.value)} sx={{ mb: 2 }} />
                <TextField fullWidth label="Code postal" variant="outlined" value={zip_code} required autoComplete="postal-code"
                onChange={(e) => setZipCode(e.target.value)} sx={{ mb: 2 }} />
                <TextField fullWidth label="Ville" variant="outlined" value={ville} required autoComplete="address-level2"
                onChange={(e) => setVille(e.target.value)} sx={{ mb: 2 }} />

                <Button variant="contained" type='submit' sx={{alignSelf: 'center', px: 5, mb: 2}}>Enregistrer</Button>

                <Backdrop open={loading}><CircularProgress/></Backdrop>

            </Container>

            <Footer />
        </Box>
    );
}